(function () {
  const CATALOG_URL = 'https://storage.googleapis.com/tracks_featured_eu/featured.json';
  const PLAY_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/></svg>';
  const PAUSE_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5"/></svg>';

  let current = null;

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function labels(root) {
    return {
      play: root.dataset.labelPlay || 'Play',
      pause: root.dataset.labelPause || 'Pause',
      playIcon: PLAY_SVG,
      pauseIcon: PAUSE_SVG,
    };
  }

  function setPlaying(card, playing, copy) {
    card.classList.toggle('is-playing', playing);
    const button = card.querySelector('[data-featured-track-play]');
    const icon = card.querySelector('[data-featured-track-icon]');
    if (!button || !icon) return;
    const name = card.dataset.trackName || '';
    button.setAttribute('aria-label', `${playing ? copy.pause : copy.play} ${name}`.trim());
    icon.innerHTML = playing ? copy.pauseIcon : copy.playIcon;
  }

  function pauseCurrent() {
    if (!current) return;
    current.audio.pause();
    setPlaying(current.card, false, current.copy);
    current = null;
  }

  function bindCard(card, copy) {
    const audio = card.querySelector('audio');
    const button = card.querySelector('[data-featured-track-play]');
    const progress = card.querySelector('[data-featured-track-progress]');
    if (!audio || !button) return;

    function toggle() {
      if (current && current.audio === audio) {
        if (audio.paused) audio.play();
        else audio.pause();
        return;
      }
      pauseCurrent();
      current = { audio, card, copy };
      audio.play();
    }

    button.addEventListener('click', function (event) {
      if (card.closest('[data-featured-tracks-viewport]')?.dataset.dragged === 'true') {
        event.preventDefault();
        return;
      }
      toggle();
    });

    button.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggle();
    });

    audio.addEventListener('play', function () {
      if (current && current.audio !== audio) current.audio.pause();
      current = { audio, card, copy };
      setPlaying(card, true, copy);
    });

    audio.addEventListener('pause', function () {
      setPlaying(card, false, copy);
      if (current && current.audio === audio) current = null;
    });

    audio.addEventListener('ended', function () {
      if (progress) progress.style.transform = 'scaleX(0)';
      setPlaying(card, false, copy);
      if (current && current.audio === audio) current = null;
    });

    audio.addEventListener('timeupdate', function () {
      if (!progress || !audio.duration) return;
      progress.style.transform = `scaleX(${audio.currentTime / audio.duration})`;
    });
  }

  function renderTrack(track, copy) {
    const name = track.name || '';
    const author = track.author || '';
    const cover = track.cover_url;
    const media = cover
      ? `<img class="featured-track__cover" src="${escapeHtml(cover)}" alt="${escapeHtml(name)}" loading="lazy" width="168" height="168" draggable="false">`
      : `<div class="featured-track__placeholder" aria-hidden="true"></div>`;

    const article = document.createElement('article');
    article.className = 'featured-track';
    article.dataset.trackId = track.id || '';
    article.dataset.trackName = name;
    article.innerHTML = `
      <div class="featured-track__cover-wrap">
        ${media}
        <div class="featured-track__play" role="button" tabindex="0" data-featured-track-play aria-label="${escapeHtml(copy.play)} ${escapeHtml(name)}">
          <span class="featured-track__play-icon" data-featured-track-icon>${copy.playIcon}</span>
        </div>
        <span class="featured-track__progress" data-featured-track-progress></span>
      </div>
      <h3 class="featured-track__name">${escapeHtml(name)}</h3>
      <p class="featured-track__author">${escapeHtml(author)}</p>
      <audio class="featured-track__audio" preload="none" src="${escapeHtml(track.audio_url || '')}"></audio>
    `;
    bindCard(article, copy);
    return article;
  }

  function pageSize(viewport, scroller) {
    const card = scroller.querySelector('.featured-track');
    if (!card) return viewport.clientWidth;
    const styles = window.getComputedStyle(card);
    const width = card.getBoundingClientRect().width + (parseFloat(styles.marginRight) || 0);
    const visible = Math.max(1, Math.floor(viewport.clientWidth / width));
    return width * visible;
  }

  function bindCarousel(root, scroller) {
    const viewport = root.querySelector('[data-featured-tracks-viewport]');
    const prev = root.querySelector('[data-featured-tracks-prev]');
    const next = root.querySelector('[data-featured-tracks-next]');
    if (!viewport) return;

    let dragging = false;
    let startX = 0;
    let startScroll = 0;
    let moved = false;

    function maxScroll() {
      return Math.max(0, scroller.scrollWidth - viewport.clientWidth);
    }

    function syncArrows() {
      if (prev) prev.disabled = viewport.scrollLeft <= 1;
      if (next) next.disabled = viewport.scrollLeft >= maxScroll() - 1;
    }

    function markDragged() {
      viewport.dataset.dragged = 'true';
      window.setTimeout(function () {
        viewport.dataset.dragged = 'false';
      }, 80);
    }

    function scrollByPage(direction) {
      viewport.scrollBy({
        left: direction * pageSize(viewport, scroller),
        behavior: 'smooth',
      });
    }

    viewport.addEventListener('scroll', syncArrows, { passive: true });

    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return;
      if (event.button !== 0) return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      viewport.dataset.dragged = 'false';
    });

    window.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      const delta = event.clientX - startX;
      if (Math.abs(delta) > 6) moved = true;
      viewport.scrollLeft = startScroll - delta;
    });

    function endMouseDrag() {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('is-dragging');
      if (moved) markDragged();
      syncArrows();
    }

    window.addEventListener('pointerup', endMouseDrag);
    window.addEventListener('pointercancel', endMouseDrag);

    let touchStartScroll = 0;
    viewport.addEventListener('touchstart', function () {
      touchStartScroll = viewport.scrollLeft;
      viewport.dataset.dragged = 'false';
    }, { passive: true });

    viewport.addEventListener('touchend', function () {
      if (Math.abs(viewport.scrollLeft - touchStartScroll) > 6) markDragged();
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { scrollByPage(-1); });
    if (next) next.addEventListener('click', function () { scrollByPage(1); });

    window.addEventListener('resize', syncArrows);
    syncArrows();
  }

  function mount(root) {
    if (!root || root.dataset.featuredTracksReady === 'true') return;
    const list = root.querySelector('[data-featured-tracks-list]');
    if (!list) return;
    root.dataset.featuredTracksReady = 'true';

    const copy = labels(root);
    const url = root.dataset.catalogUrl || CATALOG_URL;
    const freshUrl = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'v=' + Date.now();

    fetch(freshUrl, { cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('catalog');
        return response.json();
      })
      .then(function (data) {
        const tracks = Array.isArray(data && data.tracks) ? data.tracks : [];
        if (!tracks.length) {
          root.hidden = true;
          return;
        }
        const fragment = document.createDocumentFragment();
        tracks.forEach(function (track) {
          if (!track || !track.audio_url) return;
          fragment.appendChild(renderTrack(track, copy));
        });
        list.replaceChildren(fragment);
        if (!list.children.length) {
          root.hidden = true;
          return;
        }
        bindCarousel(root, list);
      })
      .catch(function () {
        root.hidden = true;
      });
  }

  function enableStoristaTrackpad() {
    document.querySelectorAll('.storista-feed').forEach(function (viewport) {
      if (viewport.dataset.oddTrackpad === 'true') return;
      viewport.dataset.oddTrackpad = 'true';

      let dragging = false;
      let x = 0;
      let y = 0;
      let endTimer = 0;

      function dispatch(type, clientX, clientY) {
        viewport.dispatchEvent(new MouseEvent(type, {
          bubbles: true,
          cancelable: true,
          view: window,
          clientX: clientX,
          clientY: clientY,
          button: 0,
          buttons: type === 'mouseup' ? 0 : 1,
        }));
      }

      viewport.addEventListener('wheel', function (event) {
        const absX = Math.abs(event.deltaX);
        const absY = Math.abs(event.deltaY);
        if (absX < 0.5 || absX <= absY) return;
        event.preventDefault();

        if (!dragging) {
          const rect = viewport.getBoundingClientRect();
          x = rect.left + rect.width / 2;
          y = rect.top + rect.height / 2;
          dragging = true;
          dispatch('mousedown', x, y);
        }

        x -= event.deltaX;
        dispatch('mousemove', x, y);
        window.clearTimeout(endTimer);
        endTimer = window.setTimeout(function () {
          dispatch('mouseup', x, y);
          dragging = false;
        }, 80);
      }, { passive: false });
    });
  }

  function init() {
    document.querySelectorAll('[data-featured-tracks]').forEach(mount);
    enableStoristaTrackpad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target && event.target.querySelector('[data-featured-tracks]');
    if (root) {
      delete root.dataset.featuredTracksReady;
      mount(root);
    }
    enableStoristaTrackpad();
  });

  if (document.body) {
    new MutationObserver(enableStoristaTrackpad).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
